import LocationService from '../../services/LocationService';

export default {
	state: {
		isTracking: false,
		coordinates: null
	},
	actions: {
		startTracking({commit}){
			LocationService.startWatching(position => {
				commit('setIsTracking', true);
				commit('setCoordinates', {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				});
			});
		},
		stopTracking({commit}){
			commit('setIsTracking', false);
			LocationService.stopWatching();
			commit('setCoordinates', null);
		}
	},
	mutations: {
		setIsTracking(state, payload) {
			state.isTracking = payload;
		},
		setCoordinates(state, payload) {
			state.coordinates = payload;
		}
	}
}
